import * as t from "io-ts";

export const OwnerReport = t.partial({
  uk_credit_aml_warnings: t.string,
  international_sanctions_warnings: t.string,
  enhanced_international_saction_warnings: t.string,
  edited_electoral_roll: t.string,
  national_id_register: t.string,
  uk_credit_header: t.string,
  overall_pass: t.string,
  adverse_media: t.string,
});

export interface OwnerReport {
  uk_credit_aml_warnings?: string;
  international_sanctions_warnings?: string;
  enhanced_international_saction_warnings?: string;
  edited_electoral_roll?: string;
  national_id_register?: string;
  uk_credit_header?: string;
  overall_pass?: string;
  adverse_media?: string;
}
